import React, { useCallback, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Results from './Results';
import './Reports.scss';
import Layout from './../Layout';
import { Helmet } from 'react-helmet';
import * as actions from './Reports.actions';
import * as selectors from './Reports.selectors';

const Reports = (props) => {
    /* State to props */
    const reportType = useSelector(selectors.getReportType);
    const platform = useSelector(selectors.getPlatform);
    const coupaOrders = useSelector(selectors.getCoupaOrders);
    const personalOrders = useSelector(selectors.getPersonalOrders);
    const managerOrders = useSelector(selectors.getManagerOrders);
    const startDate = useSelector(selectors.getStartDate);
    const endDate = useSelector(selectors.getEndDate);
    const exporting = useSelector(selectors.getExporting);
    
    /* Dispatch to props */
    const dispatch = useDispatch();
    const setReportType = useCallback((value) => dispatch(actions.setReportType(value)), [dispatch]);
    const setPlatform = useCallback((value) => dispatch(actions.setPlatform(value)), [dispatch]);
    const setOrderType = useCallback((name, value) => dispatch(actions.setOrderType(name, value)), [dispatch]);
    const setStartDate = useCallback((value) => dispatch(actions.setStartDate(value)), [dispatch]);
    const setEndDate = useCallback((value) => dispatch(actions.setEndDate(value)), [dispatch]);
    const exportReport = useCallback((value) => dispatch(actions.exportReport(value)), [dispatch]);

    return (
        <Layout
            title={<Fragment><i className="fas fa-clock"></i> Reports</Fragment>}
            history={props.history}
        >
            <Helmet>
                <title>Reports</title>
            </Helmet>
            <div className="reports-container">
                <h2>Reports</h2>
                <Results
                    reportType={reportType}
                    platform={platform}
                    coupaOrders={coupaOrders}
                    personalOrders={personalOrders}
                    managerOrders={managerOrders}
                    startDate={startDate}
                    endDate={endDate}
                    exporting={exporting}
                    setReportType={setReportType}
                    setPlatform={setPlatform}
                    setOrderType={setOrderType}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    exportReport={exportReport}
                />
            </div>
        </Layout>
    );
};

export default Reports;
